var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-center"},[_c('country-flag',{attrs:{"country":_vm.getFlag(),"size":"normal"}}),_c('v-select',{staticClass:"select",attrs:{"dense":"","items":_vm.languageArray,"item-text":"translation","item-value":"short","value":_vm.storedLanguage,"hide-details":"auto"},on:{"change":_vm.changeLanguage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }